// @flow
import React, { Fragment } from 'react'
import type { TweetCampaign } from 'types/campaign'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'
import Path from 'routes/path'
import { imagePath } from 'frontend_core/dist/helpers/image'
import RegistAccount from 'components/organisms/RegistAccount'
import moment from 'moment'

type PropTypes = {
  tweetCampaign: TweetCampaign,
  currentUser: Object,
}

export default class TweetCampaignPage extends React.Component<*> {
  props: PropTypes

  render() {
    const {
      tweetCampaign,
      currentUser,
      onClickToggleCampaignDetail,
      onClickCampaignDetail,
      isClosingCampaignDetail,
    } = this.props
    const articles = tweetCampaign.articles.results
    const rooms = tweetCampaign.rooms.results
    const details = tweetCampaign.details.results
    const features = tweetCampaign.features.results
    const now = new Date()
    const endedAt = new Date(tweetCampaign.endedAt)
    const expiredAt = endedAt.setDate(endedAt.getDate() + 1)
    const backgroundImage = tweetCampaign.eyeCatchingImage
      ? `url(${tweetCampaign.eyeCatchingImage})`
      : 'none'

    return (
      <div className="site-main">
        <article className="twcam">
          <header
            className="twcam__main"
            style={{ backgroundImage: backgroundImage }}
          >
            <p className="twcam__main-lead">
              <span>{i18n.t('page.tweetCampaign.leadStatement')}</span>
            </p>
            <div className="twcam__main-twitter">
              <p className="twcam__main-twitter-text">
                <span>{i18n.t('page.tweetCampaign.baloonTitle')}</span>
              </p>
            </div>
            <div className="twcam__main-cont">
              <h1 className="twcam__main-heading">
                <span>{tweetCampaign.eyeCatchingSubtitle}</span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: tweetCampaign.eyeCatchingTitle,
                  }}
                />
              </h1>
            </div>
          </header>

          <section className="twcam__about">
            <div className="wrapper">
              <div className="contents">
                {now.getTime() > expiredAt && (
                  <div className="twcam__message-close">
                    {i18n.t('page.tweetCampaign.closed')}
                  </div>
                )}
                <div className="twcam__message-wrap message-status--open">
                  <p className="twcam__text">
                    {tweetCampaign.prizeLeadStatement}
                  </p>
                </div>
                <h2 className="twcam__title">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: tweetCampaign.prizeTitle,
                    }}
                  />
                </h2>
                <p
                  className="twcam__main-text"
                  dangerouslySetInnerHTML={{
                    __html: tweetCampaign.prizeContent,
                  }}
                />
                {tweetCampaign.secondePrizeLeadStatement &&
                  tweetCampaign.secondePrizeTitle && (
                    <div className="twcam__chance">
                      <span>{tweetCampaign.secondePrizeLeadStatement}</span>
                      <br />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: tweetCampaign.secondePrizeTitle,
                        }}
                      />
                    </div>
                  )}
              </div>
            </div>
          </section>

          <section className="stripe-regist twcam__special">
            <div className="wrapper">
              <div className="contents">
                <h2 className="twcam__special-title">
                  <span>{tweetCampaign.articleLeadStatement}</span>
                </h2>

                <div className="twcam__special-list">
                  {articles.map(article => (
                    <div className="twcam__special-list__item" key={article.id}>
                      {article.tagTitle && (
                        <div className="twcam__special-list__bar">
                          <span>{article.tagTitle}</span>
                        </div>
                      )}
                      <div className="twcam__special-list__image">
                        <img
                          src={imageURLWithTransform(article.image, {
                            width: 900,
                            height: 600,
                            crop: 'fill',
                          })}
                          alt={article.title}
                        />
                      </div>
                      <div className="twcam__special-list__detail">
                        <div className="twcam__special-list__detail__inner">
                          <h3 className="twcam__special-item-title">
                            {article.title}
                          </h3>
                          <p
                            className="twcam__special-item-text"
                            dangerouslySetInnerHTML={{
                              __html: article.content,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="twcam__space">
            <div className="wrapper">
              <div className="contents">
                <h2 className="twcam__special-title">
                  <span>{tweetCampaign.roomLeadStatement}</span>
                </h2>
                <ul className="topics__mediumlist-space">
                  {rooms.map(room => (
                    <li className="mediumlist-space__item" key={room.id}>
                      <a href={room.roomUrl}>
                        <div className="twcam__space__image">
                          <img
                            src={imageURLWithTransform(room.image, {
                              width: 900,
                              height: 600,
                              crop: 'fill',
                            })}
                            alt={room.title}
                          />
                        </div>
                        <div className="mediumlist-space__detail">
                          <p className="mediumlist-space__spacename">
                            {room.title}
                          </p>
                          <p className="mediumlist-space__text">
                            {room.content}
                          </p>
                          <div className="mediumlist-space__info">
                            <ul className="space-head__list link__subcolor">
                              <li className="space-head__list-user">
                                <i className="fa fa-user mr5" />
                                {room.capacity}
                              </li>
                              <li className="space-head__list-map">
                                <i className="fa fa-map-marker mr5" />
                                {room.area}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
                {tweetCampaign.roomListLinkTitle &&
                  tweetCampaign.roomListLink && (
                    <p className="twcam__space__link">
                      <a href={tweetCampaign.roomListLink}>
                        {tweetCampaign.roomListLinkTitle}
                      </a>
                    </p>
                  )}
              </div>
            </div>
          </section>

          <section className="twcam__fllow">
            <div className="wrapper">
              <div className="contents">
                <h2 className="twcam__special-title">
                  <span>{i18n.t('page.tweetCampaign.applicationMethod')}</span>
                </h2>
                <div className="twcam__message-wrap message-status--open">
                  <p className="twcam__text">
                    <span>
                      {i18n.t('page.tweetCampaign.applicationPeriod')}
                    </span>
                  </p>
                </div>
                <p className="twcam__fllow-time">
                  {moment(tweetCampaign.startedAt).format(
                    i18n.t('page.shared.dateFormat1'),
                  )}
                  〜
                  {moment(tweetCampaign.endedAt).format(
                    i18n.t('page.shared.dateFormat1'),
                  )}
                </p>
                <ul className="twcam__fllow-list">
                  <li className="twcam__fllow-item">
                    <h3>
                      <span>{i18n.t('page.tweetCampaign.followTitle')}</span>
                    </h3>
                    <p className="img_twitterfllow">
                      <img
                        src={imagePath('www/campaigns/t_campaign_twitter.png')}
                        alt={i18n.t('page.tweetCampaign.twitterAccountImage')}
                      />
                    </p>
                    <p className="twcam__fllow-link">
                      <a
                        className="btn__large btn__style bg_twitter"
                        target="_blank"
                        onClick={e => {
                          e.preventDefault()
                          window.open(
                            'https://twitter.com/intent/follow?screen_name=spacemarketjp',
                            'window',
                            'width=600, height=400, menubar=no, toolbar=no, scrollbars=yes',
                          )
                        }}
                      >
                        <i className="fa fa-twitter" />
                        {i18n.t('page.tweetCampaign.followButton')}
                      </a>
                    </p>
                  </li>
                  <li className="twcam__fllow-item">
                    <h3>
                      <span>{tweetCampaign.applicationMethodTitle}</span>
                    </h3>
                    <p
                      className="twcam__fllow-text"
                      dangerouslySetInnerHTML={{
                        __html: tweetCampaign.applicationMethodContent,
                      }}
                    />
                    <p className="twcam__fllow-link">
                      <a
                        className="btn__large btn__style bg_twitter"
                        target="_blank"
                        href={
                          tweetCampaign.tweetLink.length > 0
                            ? `${tweetCampaign.tweetLink}`
                            : 'https://twitter.com/spacemarketjp'
                        }
                        rel="nofollow"
                      >
                        <i className="fa fa-twitter" />
                        {tweetCampaign.tweetLinkTitle}
                      </a>
                    </p>
                  </li>
                  <li className="twcam__fllow-item">
                    <h3>
                      <span>
                        {i18n.t('page.tweetCampaign.completeApplication')}
                      </span>
                    </h3>
                    <p className="img_mailfllow">
                      <img
                        src={imagePath('www/campaigns/t_campaign_mail.png')}
                        alt=""
                      />
                    </p>
                    <p
                      className="twcam__fllow-text"
                      dangerouslySetInnerHTML={{
                        __html: tweetCampaign.notificationMethodContent,
                      }}
                    />
                  </li>
                </ul>
                <div
                  className={`twcam__provision${
                    isClosingCampaignDetail ? ' text--close' : ''
                  }`}
                >
                  <h3>
                    <span>{i18n.t('page.tweetCampaign.mustRead')}</span>
                  </h3>
                  <div className="twcam__provision__open">
                    <span onClick={onClickToggleCampaignDetail}>
                      {i18n.t('page.tweetCampaign.agreement')}
                    </span>
                  </div>
                  <dl className="twcam__provision-text">
                    {details.map(detail => (
                      <Fragment key={detail.id}>
                        <dt>{detail.title}</dt>
                        <dd
                          dangerouslySetInnerHTML={{
                            __html: detail.content,
                          }}
                        />
                      </Fragment>
                    ))}
                  </dl>
                  <div className="twcam__provision__close">
                    <span onClick={onClickCampaignDetail}>
                      {i18n.t('page.tweetCampaign.closeDetails')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="whats">
            <div className="wrapper">
              <div className="contents">
                <h2 className="twcam__special-title">
                  <span>
                    <img src={imagePath('logo.svg')} alt="" />
                    {i18n.t('page.tweetCampaign.whatIsIt')}
                  </span>
                </h2>
                <p className="whats__text">
                  {i18n.t('page.tweetCampaign.aboutSpaceMarket')}
                  <br />
                  {i18n.t('page.tweetCampaign.aboutSpaceMarket2')}
                  <br />
                  {i18n.t('page.tweetCampaign.aboutSpaceMarket3')}
                </p>

                {features.length > 0 && (
                  <p
                    className="whats__catch"
                    dangerouslySetInnerHTML={{
                      __html: tweetCampaign.featureLeadStatement,
                    }}
                  />
                )}

                {features.map(feature => (
                  <div className="whats__see-more" key={feature.id}>
                    <div className="whats__see-more__image">
                      <img
                        src={imageURLWithTransform(feature.image, {
                          width: 900,
                          height: 600,
                          crop: 'fill',
                        })}
                        alt={feature.title}
                      />
                    </div>
                    <div className="whats__see-more__detail">
                      <h3>{feature.title}</h3>
                      <p
                        dangerouslySetInnerHTML={{ __html: feature.content }}
                      />
                      <div className="whats__see-more__btn">
                        <a href={feature.link}>{feature.linkTitle}</a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </article>
        <RegistAccount currentUser={currentUser} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/TweetCampaignPage/index.jsx